// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {

	$(document).ready(function () {

		let sitemap = document.querySelector("body.sitemap");
		if(sitemap){
			$("body.sitemap .intro-content").append($("<h2 class='hidden'>Temecula Creek Inn</h2><h3 class='hidden'>Temecula Creek Inn</h3>"))
		}

		const contact_subject = document.getElementById('subject');
		if (contact_subject) {
			contact_subject.addEventListener("change", function () {
				let this_value = this.selectedOptions[0].getAttribute('data-email');
				console.log(this_value)
				const contact_sendto = document.getElementById('sendto');
				contact_sendto.value = this_value;
			})
		};

		$('.top-content__slider').on('init', function (event, slick) {
			$('.top-content__slider .slide[data-slick-index=0]').addClass('slide-in');
		});

		$('.top-content__slider').slick();

		$('.top-content__slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			$('.top-content__slider .slide[data-slick-index=' + nextSlide + ']').addClass('slide-in');
			setTimeout(function () {
				$('.top-content__slider .slide[data-slick-index=' + currentSlide + ']').removeClass('slide-in');
			}, 800)
		});

		$('#booking-trigger').click(function (e) {
			e.preventDefault();
			ProcessNavisNCKeyword5(".temeculacreekinn.com", true, false, false, 90);
			$('#booking-content').fadeToggle();
		});

		$('#booking-close').click(function (e) {
			e.preventDefault();
			$('#booking-content').fadeToggle();
		});

		const home_body = document.querySelector('body#home');
		if (home_body) {
			/*this function add a class to header when scroll down the page
			/* and change the logo by a new file if needed depending of mockup
			*/
			scrollDownAction(20, 'scroll');
		} else {
			const logo_scroll = document.querySelector('.header__logo img').dataset.scroll;
			document.querySelector('.header__logo img').src = logo_scroll;
		}

		//Call function with browser is resized.
		// $(window).resize(function (event) {
		// 	resizeWindow();
		// });
		// resizeWindow();

		//Acts when scroll down page.
		// $(window).scroll(function (event) {
		// 	scrollDown();
		// });

		// Main Nav Dropdown
		$("#primary-nav li").hover(function () {
			$(this).addClass("hover");
			$('ul.submenu', this).fadeIn(200);
		}, function () {
			$(this).removeClass("hover");
			$('ul.submenu', this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		// const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
		// $( "#CheckIn" ).datepicker({
		// 	//showOn: "both",
		// 	//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		// 	//buttonImageOnly: true,
		// 	changeMonth: true,
		//     dateFormat: DATE_FORMAT,
		//     numberOfMonths: 1,
		// 	minDate: 0,
		// 	beforeShowDay: (date) => calendarRange(date),
		// 	onSelect: function( selectedDate ) {
		// 		let getDate = $(this).datepicker('getDate');
		// 		let newDate = new Date(getDate.getTime());
		// 		newDate.setDate(newDate.getDate() + 3);
		// 		$( "#CheckOut" ).datepicker( "setDate", newDate );
		// 		$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
		// 	}
		// });
		// $( "#CheckOut" ).datepicker({
		// 	//showOn: "both",
		// 	//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		// 	//buttonImageOnly: true,
		//     dateFormat: DATE_FORMAT,
		//     changeMonth: true,
		// 	numberOfMonths: 1,
		// 	beforeShowDay: (date) => calendarRange(date),
		// 	onSelect: function( selectedDate ) {
		// 		//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
		// 	}
		// });

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		/* animation cleanlines section homepage */
		$('.clean-lines-button').click(function() {
		    if($('.clean-lines-section').css("left") == "-420px")
		    {
		        $(".clean-lines-section").animate({left: '0'});
		        $('.clean-lines-button').fadeOut();
		        $('.close-cleanlines').fadeIn();
		    }
		    else
		    {
		       $(".clean-lines-section").animate({left: '-420px'});
		       $('.clean-lines-button').fadeIn();
		       $('.close-cleanlines').fadeOut();
		    }
		});

		$('.close-cleanlines').click(function() {
			$(".clean-lines-section").animate({left: '-420px'});
			$('.clean-lines-button').fadeIn();
		});

		//timeline(document.querySelectorAll('.timeline'));

	});

	window.onload = function () {




		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})

		$('.gallery_slider .slick-current').addClass('active');
		$('.gallery_slider .slick-current').prev().addClass('active');
		$('.gallery_slider .slick-current').next().addClass('active');
		$('.gallery_slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			$('.gallery_slider .slick-slide').removeClass('active');
			$('.gallery_slider .slick-slide[data-slick-index="' + nextSlide + '"]').addClass('active');
			$('.gallery_slider .slick-slide[data-slick-index="' + nextSlide + '"]').prev().addClass('active');
			$('.gallery_slider .slick-slide[data-slick-index="' + nextSlide + '"]').next().addClass('active');
			//console.log(nextSlide);
		});
	};

	function navisEmailSignup(formID) {

		$.post(site_url + 'ajax/emailsignup.php', $("#" + formID).serialize(), function (data) {
			if (data.error) {
				if (formID == 'email-signup2')
					$("#email-error2").html(data.msg);
				else
					$("#email-error").html(data.msg);

			} else {
				//ga('send', 'event', 'form', 'click', 'specials');
				$("#" + formID).html('<p>Thank You</p>');

			}
		}, 'json');

	}

	// console.log($("[data-tag='Golf']").length)
	// if($("[data-tag='Golf']").length > 0){
	// 	$(`[data-tag='Golf']`)[0].click()
    //         setTimeout(() => {
    //         $('html, body').animate({ scrollTop: $('#moduleFilter').offset().top - 10 }, 1000);
                       
    //         }, 500);
	// }




}());

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate-fade-2');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if (topPos <= window_height * 0.8) {
			animatedEl[i].classList.add('fade-in');
		}
	}
}



function slideNextContent(btn, className) {
	btn.click(function (event) {
		let $this = $(this);
		event.preventDefault();
		$this.toggleClass(className);
		$this.next().slideToggle();
	});
}
function showContent(btn, content, className) {
	btn.click(function (event) {
		let $this = $(this);
		event.preventDefault();
		$this.toggleClass(className);
		content.fadeToggle();
	});
}

$(function () {

	// scrollW();
	// window.addEventListener('scroll', function(){
	// 	scrollW();
	// })

	$('.close-res').click(function (event) {
		event.preventDefault();
		$('html').removeClass('hide-overflow');

		$('.booking-widget').stop().animate({ left: '100%' }, { queue: false, duration: 300 });
	});


	/*MOBILE MENU NAV
	****************************************************************/

	//Open Navigation
	$('#menu-btn').click(function (event) {
		$('html').addClass('hide-overflow');
		$('.navigation').addClass('open');
		$('.navigation').stop().animate({ left: '0px' }, { duration: 300 });
		if ($('.navigation ul li a').hasClass('.item-open')) {
			$(".item-open").get(0).scrollIntoView(false);
		}
	});

	$('.close-menu').click(function (event) {
		event.preventDefault();
		$('html').removeClass('hide-overflow');
		$('.navigation').removeClass('open');
		$('.navigation').stop().animate({ left: '100%' }, { queue: false, duration: 300 });
	});

	//SUBNAVIGATION

	// Open active sub-nav on load
	$('.navigation ul.submenu li .active').closest('.inner').addClass('open')
	$('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
	$('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, function () { }).addClass('menu-open');

	$(".fancybox").fancybox();

	//Toggle open/close on tap
	$('.navigation li a').off('click').on('click', function (event) {
		if ($(this).parent().children(".sub-sub-menu").length > 0) {

			event.preventDefault();

			if ($(this).next().hasClass('menu-open')) {
				$(this).closest('.inner').removeClass('open');
				$('.navigation ul li').removeClass('item-open');
				$(this).parent().addClass('item-open');
				$(this).next().slideUp(300, function () {
					if ($('.navigation ul li a').hasClass('active')) {
						$(".item-open").get(0).scrollIntoView(false);
					}
				}).removeClass('menu-open');
			} else {
				$(this).closest('.inner').addClass('open');
				$('.navigation ul li').removeClass('item-open');
				$(this).parent().addClass('item-open');
				$('.sub-sub-menu.menu-open').slideUp(300).removeClass('menu-open');
				$(this).next().addClass('menu-open').slideDown(300, function () {
					if ($('.navigation ul li a').hasClass('active')) {
						$(".item-open").get(0).scrollIntoView(false);
					}
				});
			}
		}
	});

});

window.addEventListener("load", (event) => {
	document.querySelector('footer').style.overflow = "hidden";
	console.log("WINDOW");
});